import styles from './About.module.css';

function About() {
    return (
        <section id="sobre" className={styles.about}>
            <img src="/img/logos/logo3.webp" className="mb-2" alt="Focus" />
            <h2>O que é o Focus?</h2>
            <p>O Focus é um <b>aplicativo mobile de banco de horas de uso pessoal</b>, ou seja, é voltado para usuários comuns, não para empresas. Por meio do Focus você mantém um <b>registro diário do andamento de suas atividades no decorrer do mês</b>, contendo os horários de início, término e a duração da atividade em cada data em que ela foi realizada.</p>
        </section>
    );
}

export default About